(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const viewportQuery = window.matchMedia('(min-width: 750px)');
  const initialized = new WeakMap();

  const includeSelf = (scope, selector) => {
    const matches = [];
    if (scope instanceof Element && scope.matches(selector)) matches.push(scope);
    if (scope?.querySelectorAll) matches.push(...scope.querySelectorAll(selector));
    return matches;
  };

  const enhance = (root) => {
    if (initialized.has(root)) return;
    const tablist = root.querySelector('[data-ff-sabbia-tablist]');
    const groups = [...root.querySelectorAll('[data-ff-sabbia-group]')];
    if (!tablist || groups.length < 2) return;

    const sync = () => {
      const tabs = [...tablist.querySelectorAll('[role="tab"]')];
      if (tabs.length !== groups.length) {
        requestAnimationFrame(sync);
        return;
      }
      root.classList.add('is-enhanced', 'is-spec-tabs');
      tablist.hidden = false;
      tablist.setAttribute('role', 'tablist');
      const heading = root.querySelector('.ff-sabbia-info__heading');
      if (heading?.id) tablist.setAttribute('aria-labelledby', heading.id);
      let selected = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      if (selected < 0) selected = Math.max(0, groups.findIndex((group) => group.open));
      if (selected < 0) selected = 0;
      groups.forEach((group, index) => { group.open = index === selected; });
      tabs.forEach((tab, index) => {
        tab.setAttribute('aria-selected', String(index === selected));
        tab.tabIndex = index === selected ? 0 : -1;
      });
    };

    const keepSelectedVisible = (event) => {
      const tab = event.target.closest?.('[role="tab"]');
      if (!tab || !tablist.contains(tab)) return;
      requestAnimationFrame(() => tab.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      }));
    };

    const onViewportChange = () => requestAnimationFrame(sync);
    tablist.addEventListener('click', keepSelectedVisible);
    tablist.addEventListener('keydown', keepSelectedVisible);
    viewportQuery.addEventListener('change', onViewportChange);
    sync();

    initialized.set(root, () => {
      tablist.removeEventListener('click', keepSelectedVisible);
      tablist.removeEventListener('keydown', keepSelectedVisible);
      viewportQuery.removeEventListener('change', onViewportChange);
      root.classList.remove('is-spec-tabs');
    });
  };

  const destroy = (root) => {
    initialized.get(root)?.();
    initialized.delete(root);
  };

  const scan = (scope = document) => includeSelf(scope, '[data-ff-sabbia-info]').forEach(enhance);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => includeSelf(event.target, '[data-ff-sabbia-info]').forEach(destroy));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();
